<form [formGroup]="form" class="app-install-trigger-form last-signal-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section formGroupName="signal" class="section">
    <header class="section-header">
      <h4>Last Signal</h4>
      <span class="hint">Required</span>
    </header>

    <div class="mode-toggle">
      <app-trigger-mode-radio-group
        formControlName="mode"
        [options]="signalModeOptions"
      ></app-trigger-mode-radio-group>
    </div>

    <p class="hint" *ngIf="signalMode === 'generate'">
      A sandbox signal will be generated and backdated to match the flow's Time
      Since Last Signal interval. The account's first available template and
      category are used for required signal references.
    </p>

    <div class="fields" *ngIf="signalMode === 'specify'">
      <div class="field">
        <label>Headline</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="headline" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>Push Text</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="text" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>Content</label>
        <mat-form-field appearance="outline">
          <textarea matInput formControlName="content"></textarea>
        </mat-form-field>
      </div>

      <div class="field">
        <label>Tags</label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="tags" placeholder="sandbox,flow-test" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>View Count</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="view_count" />
        </mat-form-field>
      </div>
    </div>

    <p class="hint" *ngIf="signalMode === 'specify'">
      These values are saved to the sandbox signal row. The signal timestamp is
      still derived from the selected flow's interval.
    </p>
  </section>
</form>
